<template>
<!--  <van-nav-bar safe-area-inset-top>-->
<!--    <template #title>-->
    <div>
      <div style="position: fixed;z-index: 9999999;  width: 100%; box-sizing: border-box; height: 52px;padding: 0px 20px;background-color: #FFFFFF; display: flex;align-items: center;">
          <div style="flex: 1; display: flex;">
            <div v-on:click="gotoHome" style="display: flex;align-items: center;">
              <img :src="require('@/assets/logonew.png')" class="logo" />
              <div style="margin-left: 9px; background-image: linear-gradient(90deg, #FF8C3B 0%, #FF6600 100%); padding:0 8px; border-radius: 12px;height: 22px;line-height: 22px;font-family: PingFangSC-Medium;font-size: 12px;color: #FFFFFF;font-weight: 500; ">校园招聘</div>
            </div>
            <div style="flex: 1;"></div>
          </div>
          <van-dropdown-menu>
            <van-dropdown-item ref="item">
              <template #title>
                <img v-if="!showMenu" :src="require('@/assets/menu.png')" class="menu" />
                <img v-if="showMenu" :src="require('@/assets/close.png')" class="menu" />
              </template>
              <van-cell :clickable="false" :title="'你好，'+(user.isLogin?user.username?user.username:user.tel:'游客')" style="user-select: none;transition-duration: 0s;">
                <template #extra>
                  <a v-if="user.isLogin && app=='M'" @click="logout">退出</a>
                </template>
              </van-cell>
              <van-cell is-link title="校招首页" @click="goto('index')">
              </van-cell>
<!--              <van-cell is-link title="管培生计划" @click="goto('intro')">-->
<!--              </van-cell>-->
              <van-cell is-link title="招聘职位" @click="goto('positionlist')">
              </van-cell>
              <van-cell is-link title="应聘进度" @click="goto('deliverylist')">
              </van-cell>
              <van-cell is-link title="答疑专区" @click="goto('qa')">
              </van-cell>
            </van-dropdown-item>
          </van-dropdown-menu>
      </div>
      <div style="height: 52px;"></div>
    </div>
<!--    </template>-->
<!--  </van-nav-bar>-->
</template>

<script>
import Vue from 'vue';
import {
  Popover,
  Image as VanImage,
  Toast,
  NavBar,
  DropdownMenu,
  DropdownItem
} from 'vant';
import Request from "../utils/Request";
import Urls from "../utils/Urls";
import Utils from "../utils/Utils";
import wx from "weixin-js-sdk";
Vue.use(NavBar);
Vue.use(Popover);
Vue.use(VanImage);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
export default {
  name: "Header1",
  props: {
    left: {
      type: Boolean,
      default: false
    },
    leftText: {
      type: String,
      default: ''
    },
    title:{
      type:String,
      default:''
    },
  },
  data(){
    return {
      app:"",
      showMenu:false,
      user:{
        isLogin:false
      },
    };
  },
  mounted: function()
  {
    // try {
    //   let isProd = (process.env.NODE_ENV == 'production' ? true : false);
    //   window.TDTP && window.TDTP.init(isProd, "效能", "招聘官网", '');
    // } catch(e) {
    //   console.error(e)
    // }
    this.app=Utils.getApp();
    // if(this.app=='WeiXinMini')
    // {
    //     window.history.pushState({page:1},null,window.location.href);
    //     window.addEventListener('popstate',(event)=>{
    //       wx.miniProgram.navigateBack();
    //     });
    // }
    this.getLoginName();

    Request.request(Urls.addAccessLog, {
      app:"Campus_"+this.app,
      url: window.location.href,
      router: window.location.hash,
      referer: window.document.referrer
    });

  },
  methods: {
    getLoginName(){
      let that = this;
      Toast.loading({
        duration: 0,
        forbidClick: true,
      });
      Request.request(Urls.getLoginName).then(res=>{
        Toast.clear();
        if (res) {
          that.user=res;

          try {
            window.TDTP && window.TDTP.setUserAccount(res.userid||'');
          } catch(e) {
            console.error(e)
          }

        }
      });
    },
    logout(){
      let that = this;
      Toast.loading({
        duration: 0,
        forbidClick: true,
      });
      Request.request(Urls.logout).then(res=>{
        Toast.clear();
        if (res) {
          this.$router.push({path:'/'});
        }
      });
    },
    onClickLeft(){
      if(this.app=='WeiXinMini')
      {
        Toast.loading({
          duration: 500,
          forbidClick: true,
        });
        wx.miniProgram.navigateBack({
          delta: 1,
          complete:()=>{
            Toast.clear();
          }
        });
      }
      else
      {
        this.$router.go(-1);
      }
    },
    goto(url){
      let app=Utils.getApp();
      if(app=='WeiXinMini' && url=='index')
      {
        Toast.loading({
          duration: 500,
          forbidClick: true,
        });
        wx.miniProgram.switchTab({
          url: '/pages/m/m',
          complete: () => {
            Toast.clear();
          }
        });
      }
      else if(app=='WeiXinMini' && this.$route.query.minipage=='m')
      {
          Toast.loading({
            duration: 500,
            forbidClick: true,
          });
          wx.miniProgram.navigateTo({
            url: '/pages/m/child?url=' + encodeURIComponent(url),
            complete: () => {
              Toast.clear();
            }
          });
      }
      else
      {
        this.$router.push({path:url});
      }
      this.$refs.item.toggle();
    },
    gotoHome()
    {
      if(app=='WeiXinMini' && this.$route.query.minipage=='m')
      {
        Toast.loading({
          duration: 500,
          forbidClick: true,
        });
        wx.miniProgram.switchTab({
          url: '/pages/m/child?url=index',
          complete: () => {
            Toast.clear();
          }
        });
      }
      else
      {
        this.$router.push({path:'index'});
      }
    },
    onOpen()
    {
      this.showMenu=!this.showMenu;
    }
  }
}
</script>
<style scoped>
.van-nav-bar{
  background: rgb(255, 255, 255);
  margin: 0;
  padding: 0;
  height: 52px;
  /*position: static;*/
}
.van-hairline--bottom::after
{
  border-bottom-width: 0;
}
.van-nav-bar>>> .van-nav-bar__title {
  max-width: 100%;
  width: 100%;
  margin: 0;
  padding: 0;
}
.van-nav-bar>>> .van-nav-bar__content {
  height: 52px;
}

.logo{
  width: 69px;
  height: 29px;
}
.menu{
  width: 24px;
  height: 24px;
}

.van-dropdown-menu>>> .van-dropdown-menu__bar {
  box-shadow: none;
  height: 22px;
  background-color: transparent;
}
.van-dropdown-menu>>> .van-dropdown-menu__title {
  padding:0;
  color: #323233;
}
.van-dropdown-menu>>> .van-dropdown-menu__title--active {
  color: #323233;
}
.van-dropdown-menu>>> .van-dropdown-menu__title::after {
  content: none;
}
.van-dropdown-menu>>> .van-dropdown-menu__item:active{
  opacity:1
}
.van-dropdown-menu>>> .van-ellipsis {
  display: flex;
  justify-content: center;
}
.van-dropdown-menu>>> .van-overlay,
.van-dropdown-menu>>> .van-popup--top {
  top: 12px;
}

.van-cell{
  width: auto;
  margin: 0 16px;
  padding: 16px 0;
  border-bottom: 1px solid #E6EBF5;
}
.van-cell::after {
  border-bottom: none;
}
.van-cell>>> .van-cell__title{
  text-align: left;
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #111E36;
  height: 16px;
  font-weight: 400;
}
.van-cell>>> .van-cell__right-icon {
  color: #7b8191 !important;
}

</style>
